import {Box, HBox} from '../../../components/core/view';
import {CustomText, H5Text} from '../../../components/core/text';
import React, {Fragment, useMemo} from 'react';
import {RunForBatchDetail, UPCOrder} from '../../../batchDetails/types';
import {useColorThemeType, useFontTheme} from '../../../appStyles/hooks/theme';

import {Divider} from 'native-base';
import If from '@buncha/components/conditional/If';
import {Modules} from '@buncha/utils/types';
import {ShopperScreens} from '@buncha/home/navigation/types';
import StoreLogo from '../../../common/components/StoreLogo';
import {styles} from './styles';
import {useAppSelector} from '@buncha/config/redux/hooks';
import {useGetLocale} from '@buncha/localization/hooks';

interface BatchDetailHeaderProps {
  runDetail?: RunForBatchDetail;
  showRunPill: boolean;
  upcOrderData?: UPCOrder;
  hidSubText?: boolean;
}

export default function BatchDetailHeader(props: BatchDetailHeaderProps) {
  const {runDetail, showRunPill, upcOrderData, hidSubText} = props;
  const theme = useColorThemeType();
  const muliFont = useFontTheme('muli');
  const {title, body} =
    useGetLocale(Modules.batchDetails, ShopperScreens.BatchDetailsPage) ?? {};
  const shopperTaskInfo = useAppSelector(
    gbState => gbState.batchDetail.batchTaskInfo,
  )?.shopperTask;

  const storeName = useMemo(() => {
    if (showRunPill) return runDetail?.storeName;
    return upcOrderData?.storeName;
  }, [runDetail?.storeName, showRunPill, upcOrderData?.storeName]);
  const storeLogo = useMemo(() => {
    if (showRunPill) return runDetail?.store?.storeLogoUrl;
    return upcOrderData?.storeLogo;
  }, [runDetail?.store?.storeLogoUrl, showRunPill, upcOrderData?.storeLogo]);

  return (
    <Fragment>
      <Divider style={styles.divider} />
      <HBox style={[styles.mainContainer]}>
        <HBox>
          <StoreLogo storeLogoUrl={storeLogo ?? ''} />
          <Box style={[styles.runInfoContainer]}>
            <H5Text
              numberOfLines={1}
              style={[
                styles.runName,
                {
                  fontFamily: muliFont[900].normal,
                  color: theme?.text.blue[300],
                },
              ]}>
              {storeName}
            </H5Text>
            <If condition={runDetail?.locationAddress.length}>
              <CustomText
                numberOfLines={1}
                style={[
                  styles.runName,
                  {
                    fontFamily: muliFont[600].normal,
                    color: theme?.text.gray[100],
                  },
                ]}>
                {runDetail?.locationAddress}
              </CustomText>
            </If>
            <If condition={!showRunPill}>
              <CustomText
                style={[
                  styles.runName,
                  {
                    fontFamily: muliFont[600].normal,
                    color: theme?.text.gray[100],
                  },
                ]}>
                {upcOrderData?.esIndex}
              </CustomText>
            </If>
            <If condition={showRunPill && !hidSubText}>
              <CustomText
                style={[
                  styles.runName,
                  {
                    fontFamily: muliFont[600].normal,
                    color: theme?.text.gray[100],
                  },
                ]}>
                {shopperTaskInfo?.orderCount}
                {body?.ordersAssignedTotal?.[0]}
                {shopperTaskInfo?.itemCount}
                {body?.ordersAssignedTotal?.[1]}
              </CustomText>
            </If>
          </Box>
        </HBox>
        <If condition={showRunPill}>
          <Box
            style={[
              styles.runIdContainer,
              {
                backgroundColor: theme?.background.gray[200],
              },
            ]}>
            <CustomText
              style={[
                styles.runIdText,
                {
                  fontFamily: muliFont[600].normal,
                  color: theme?.text.gray[100],
                },
              ]}>
              {title?.runId?.replace('{runId}', runDetail?.id)}
            </CustomText>
          </Box>
        </If>
      </HBox>
    </Fragment>
  );
}
